/* eslint-disable no-restricted-imports */
import { getBuildEnvVar, getRuntimeEnvVar } from '@wizbii/angular-utilities';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJsonVersionAtBuild = require('../../package.json').version; // tslint:disable-line

const production = false;
const apiDomainDefaultStaging = getRuntimeEnvVar('API_DOMAIN');
const apiDomainDefaultQa3 = getRuntimeEnvVar('API_DOMAIN_BIS');
const apiDomain1j1s = getRuntimeEnvVar('API_DOMAIN_1J1S');
const apiPlatformStaging = getRuntimeEnvVar('API_PLATFORM_BIS');
const analyticsUai = getRuntimeEnvVar('WIZBII_ANALYTICS_UAI');
const platform = getRuntimeEnvVar('PLATFORM');
const localhost = 'http://localhost:4200';

const ciCommitSha = getBuildEnvVar('CI_COMMIT_SHA');
const deployAssetsUrl =
  production && ciCommitSha
    ? `https://storage.googleapis.com/wizbii-application-assets/1jeune1solution/${ciCommitSha}/fr/assets/`
    : null;

export const environment = {
  applicationId: '1jeune1solution',
  platform: getRuntimeEnvVar('PLATFORM'),
  apiDomain: apiDomainDefaultStaging,
  apiDomain1j1s,
  isDeployed: !!getRuntimeEnvVar('PLATFORM'),
  production,
  version: production ? packageJsonVersionAtBuild : getBuildEnvVar('GIT_BRANCH_NAME'),
  url: platform !== 'local' ? `https://${apiDomain1j1s}` : localhost,
  i18n: {
    lang: 'fr',
    locale: 'fr_FR',
  },
  bugsnag: {
    key: getRuntimeEnvVar('BUGSNAG_KEY'),
  },
  domain: {
    wizbii: getRuntimeEnvVar('WIZBII_ENV_FQDN'),
  },
  paging: {
    item_per_page: 40,
    max_hits: 1000,
  },
  api: {
    contact: `https://contact.api.${apiDomainDefaultStaging}`,
    domain: apiDomainDefaultQa3,
    file: `https://file.${apiDomainDefaultStaging}`,
    googleStorage: 'https://storage.googleapis.com',
    imaginary: `https://imaginary.${apiDomainDefaultStaging}`,
    job: `https://job-api.${apiDomainDefaultStaging}`,
    job_api_v2: `https://job-v2.api.${apiDomain1j1s}`,
    job_importer: `https://api.job-importer.${apiDomainDefaultStaging}`,
    opsEvent: `https://ops-event.api.${apiDomainDefaultStaging}`,
    event: `https://event.api.${apiDomain1j1s}`,
    place: `https://place.${apiDomainDefaultStaging}`,
    school: `https://school-api.${apiDomainDefaultStaging}`,
    content: `https://content-api.${apiDomainDefaultStaging}`,
    poleEmploi: `https://api.emploi-store.fr`,
    company: `https://company.api.${apiDomain1j1s}`,
    opsCompany: `https://company-api.${apiDomainDefaultStaging}`,
    organization: `https://organization.api.${apiDomain1j1s}`,
    lba: `https://labonnealternance.apprentissage.beta.gouv.fr`,
    abtest: `https://abtest-api.${apiDomainDefaultStaging}`,
  },
  algolia: {
    applicationId: getRuntimeEnvVar('ALGOLIA_APP_ID'),
    apiKey: getRuntimeEnvVar('ALGOLIA_API_KEY'),
    index: {
      poleEmploiCommunes: `${apiPlatformStaging}_pole-emploi_communes`,
      poleEmploiDepartments: `${apiPlatformStaging}_pole-emploi_departements`,
      poleEmploiRegions: `${apiPlatformStaging}_pole-emploi_regions`,
      articles: `${apiPlatformStaging}_content_article_1j1s-mesures`,
      missionsLocales: `${apiPlatformStaging}_1j1s_missions_locales`,
      organizations: `${apiPlatformStaging}_1j1s_organization_front`,
      events: `${apiPlatformStaging}_1j1s_public_event`,
      companies: `${apiPlatformStaging}_1j1s_company_front`,
      missionsCivicService: `${apiPlatformStaging}_1j1s_mission`,
      volunteerService: `${apiPlatformStaging}_1j1s_mission`,
      internship: `${apiPlatformStaging}_1j1s_public_stages`,
      news: `${apiPlatformStaging}_1j1s_news_sorted_by_scheduling-date_asc`,
      trainings: `${apiPlatformStaging}_1j1s_formation`,
      institutes: `${apiPlatformStaging}_1j1s_public_institute`,
      jobdating: `${apiPlatformStaging}_1j1s_event_client`,
    },
  },
  analytics: {
    waTrackingId: analyticsUai,
    gaTrackingId: analyticsUai,
    gtagTrackingId: getRuntimeEnvVar('GTAG_TRACKING_ID'),
    hotjar: {
      id: getRuntimeEnvVar('HOTJAR_ID'),
      version: '6',
    },
    atInternetId: getRuntimeEnvVar('AT_INTERNET_ID'),
    facebookPixel: {
      appId: getRuntimeEnvVar('FACEBOOK_PIXEL_APP_ID'),
      version: getRuntimeEnvVar('FACEBOOK_PIXEL_VERSION'),
    },
    snapchatId: getRuntimeEnvVar('SNAPCHAT_PIXEL_APP_ID'),
  },
  deployAssetsUrl,
  wizbiiFiles: getRuntimeEnvVar('FILE_API_BUCKET'),
  wizbiiImages: 'https://storage.googleapis.com/wizbii-images/1jeune1solution',
};

if (!production) {
  import('zone.js/dist/zone-error' as any); // Included with Angular CLI.
}
